import { useQuery } from 'react-query'
import { getRepaymentsBreakdowns } from 'shared/models/repayments'

import { CacheKeys } from '../../helpers/cacheKeys'

interface UseRepaymentsBreakdowns {
  teamId?: string
  vendorId?: string
  enabled?: boolean
}

export function useRepaymentsBreakdowns({ teamId, vendorId, enabled = true }: UseRepaymentsBreakdowns) {
  const { data, isLoading, isFetching } = useQuery(
    `${CacheKeys.REPAYMENTS_BREAKDOWNS}-${teamId}-${vendorId}`,
    () => getRepaymentsBreakdowns({ teamId, vendorId }),
    {
      enabled: Boolean(enabled && Boolean(teamId || vendorId)),
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

  return {
    repaymentsBreakdowns: data,
    isLoading,
    isFetching,
  }
}
